import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const FIELDS = [
  { k: "name", l: "Full name", p: "Jane Spotless", type: "text" },
  { k: "email", l: "Email", p: "jane@example.com", type: "email" },
  { k: "phone", l: "Phone", p: "(555) 000-0000", type: "tel" },
  { k: "property_size", l: "Property size (optional)", p: "e.g. 3 bed / 2,000 sq ft", type: "text" },
];

export const DetailsStep = ({ form, setForm }) => {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const cls = "h-12 rounded-none border-white/15 bg-[#111317] text-base text-zinc-100 placeholder:text-zinc-500 focus-visible:ring-[var(--acid)]";
  return (
    <div className="grid gap-5 sm:grid-cols-2">
      {FIELDS.map((f) => (
        <div key={f.k} className="flex flex-col gap-2">
          <Label className="eyebrow" htmlFor={f.k}>{f.l}</Label>
          <Input id={f.k} type={f.type} value={form[f.k]} onChange={set(f.k)} placeholder={f.p} className={cls} data-testid={`booking-input-${f.k}`} />
        </div>
      ))}
      <div className="flex flex-col gap-2 sm:col-span-2">
        <Label className="eyebrow" htmlFor="address">Address</Label>
        <Input id="address" value={form.address} onChange={set("address")} placeholder="Street, city, zip" className={cls} data-testid="booking-input-address" />
      </div>
      <div className="flex flex-col gap-2 sm:col-span-2">
        <Label className="eyebrow" htmlFor="notes">Anything we should know? (optional)</Label>
        <Textarea id="notes" value={form.notes} onChange={set("notes")} rows={4} placeholder="Pets, gate codes, the room nobody's touched since 2019…"
          className="rounded-none border-white/15 bg-[#111317] text-base text-zinc-100 placeholder:text-zinc-500 focus-visible:ring-[var(--acid)]" data-testid="booking-input-notes" />
      </div>
    </div>
  );
};
